/* ==================================================================
   IIJAN LP MOTION — v1.0
   スクロール演出をまとめて面倒みる小さなランタイム。
   依存なし。prefers-reduced-motion を尊重する。
   ================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1. 出現アニメーション ------------------------------------ */
  function observeReveals(root) {
    var targets = (root || document).querySelectorAll('.ij-r:not([data-ij-seen]), .ij-rise:not([data-ij-seen]), .ij-zoom:not([data-ij-seen])');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-ij-seen', ''); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    targets.forEach(function (el) { el.setAttribute('data-ij-seen', ''); io.observe(el); });
  }

  /* --- 2. 一語ずつ灯る見出し ------------------------------------ */
  function lightUpStatements(root) {
    var nodes = (root || document).querySelectorAll('[data-ij-words]:not([data-ij-split])');
    nodes.forEach(function (node) {
      node.setAttribute('data-ij-split', '');
      // 既存の子要素（.ij-tag など）は壊さず、テキストノードだけを分割する。
      // .ij-tag は background-clip:text で箔色を出しているため、中に .ij-w を
      // 入れ子にすると「自分の直接の文字」が無くなり描画対象が消えてしまう
      // 環境がある（= 強調文字だけ表示されない）。そのため .ij-tag の中身は
      // 分割せずそのまま残す。
      var idx = 0;
      var walk = function (parent) {
        Array.prototype.slice.call(parent.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var text = child.nodeValue;
            if (!text.trim()) return;
            var frag = document.createDocumentFragment();
            // ラテンは語単位、和文は文字単位。ただし句読点・閉じ括弧は
            // 直前の文字にくっつけて切る（行頭に「、」が来る禁則崩れを防ぐ）。
            var pieces = text.match(/[A-Za-z0-9'’.,!?-]+|\s+|[「『（〔【＜《“‘]*[\s\S][、。，．！？」』）〕】＞》”’ー…]*/g) || [];
            pieces.forEach(function (p) {
              if (!p.trim()) { frag.appendChild(document.createTextNode(p)); return; }
              var s = document.createElement('span');
              s.className = 'ij-w';
              // 文が長いほど最後の一片が灯るまでの待ち時間が伸び、スマホの
              // 素早いスクロールでは最後まで灯る前に画面外へ出てしまう。
              // 遅延の伸びに上限を設け、どれだけ長い文でも一定時間内に
              // 全体が灯り終えるようにする。
              s.style.setProperty('--w', Math.min(idx++, 16));
              s.textContent = p;
              frag.appendChild(s);
            });
            parent.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            if (child.classList && child.classList.contains('ij-tag')) { return; }
            walk(child);
          }
        });
      };
      walk(node);

      if (reduce || !('IntersectionObserver' in window)) { node.classList.add('is-lit'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          node.classList.add('is-lit');
          io.disconnect();
        });
      }, { threshold: 0.35 });
      io.observe(node);
    });
  }

  /* --- 3. ヒーロー動画：再生が始まったらフェードイン -------------- */
  function primeHeroVideo(root) {
    (root || document).querySelectorAll('video[data-ij-video]:not([data-ij-primed])').forEach(function (v) {
      v.setAttribute('data-ij-primed', '');
      var show = function () { v.classList.add('is-playing'); };
      if (v.readyState >= 3) show();
      v.addEventListener('loadeddata', show, { once: true });
      v.addEventListener('playing', show, { once: true });
      // iOS Low Power Mode などで自動再生が拒否された場合はポスターのままにする
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function () { /* 静止画のまま */ }); }
    });
  }

  /* --- 4. マーキー：内容を複製して途切れなく流す ------------------ */
  function buildMarquees(root) {
    (root || document).querySelectorAll('.ij-marquee__track:not([data-ij-dup])').forEach(function (track) {
      track.setAttribute('data-ij-dup', '');
      var group = track.querySelector('.ij-marquee__group');
      if (!group) return;
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  /* --- 5. 固定ナビ：スクロールしたら面を出す --------------------- */
  function stickyNav() {
    var nav = document.querySelector('.ij-nav');
    if (!nav) return;
    var sentinel = document.createElement('span');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80vh;pointer-events:none;';
    document.body.appendChild(sentinel);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      nav.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  /* --- 6. 手紙の開閉 -------------------------------------------- */
  function letters(root) {
    (root || document).querySelectorAll('.ij-letter__toggle:not([data-ij-bound])').forEach(function (btn) {
      btn.setAttribute('data-ij-bound', '');
      btn.addEventListener('click', function () {
        var box = btn.closest('.ij-letter');
        if (!box) return;
        var open = box.hasAttribute('open-letter');
        if (open) { box.removeAttribute('open-letter'); } else { box.setAttribute('open-letter', ''); }
        btn.setAttribute('aria-expanded', String(!open));
        var label = btn.querySelector('[data-label]');
        if (label) { label.textContent = open ? label.getAttribute('data-label') : label.getAttribute('data-label-open'); }
      });
    });
  }

  /* --- 7. アンカーのなめらかスクロール --------------------------- */
  function smoothAnchors(root) {
    (root || document).querySelectorAll('a[href^="#ij-"]:not([data-ij-bound])').forEach(function (a) {
      a.setAttribute('data-ij-bound', '');
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        var t = document.querySelector(href);
        if (!t) {
          // JSONテンプレートのセクションは section.id が "template--12345__ij_rail_apparel"
          // のような動的な文字列になり、設定側で書いた固定のアンカー（#ij-ij_rail_apparel）とは
          // 一致しない。そのキー名で終わる id を探すフォールバックで拾う。
          var key = href.slice(4);
          if (key) t = document.querySelector('[id$="__' + key + '"]');
        }
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }


  /* --- 8. スクロール連動：イマーシブ・スクロールと奥行き ----------
     スクロール中だけ requestAnimationFrame を回し、見えているものだけ計算する。
     ・.ij-immerse … 進み具合 --p（0〜1）を渡し、文字を段階的に切り替え、
                      動画を「速さ連動」か「早送り・巻き戻し」で動かす
     ・[data-ij-parallax] [data-ij-depth] … 深さに応じて上下にずらす */
  var scenes = [];
  var layers = [];
  var lastY = window.pageYOffset, lastT = 0, speed = 0, ticking = false;

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function bindImmersive(root) {
    // テーマエディタで差し替えられたセクションの古い参照を捨てる
    scenes = scenes.filter(function (x) { return x.el.isConnected; });
    (root || document).querySelectorAll('[data-ij-immerse]:not([data-ij-bound])').forEach(function (el) {
      el.setAttribute('data-ij-bound', '');
      var video = el.querySelector('[data-ij-immerse-video]');
      var scene = {
        el: el,
        mode: el.getAttribute('data-mode') || 'loop',
        video: video,
        lines: Array.prototype.slice.call(el.querySelectorAll('.ij-immerse__line')),
        step: -1,
        rate: 1,
        visible: false
      };
      if (reduce) {
        el.style.setProperty('--p', 1);
        scene.lines.forEach(function (l) { l.classList.add('is-on'); });
        return;
      }
      if (video && scene.mode === 'scrub') { video.pause(); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          scene.visible = entries[0].isIntersecting;
          if (!video || scene.mode === 'scrub') return;
          if (scene.visible) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } else { video.pause(); }
        }, { rootMargin: '10% 0px' }).observe(el);
      } else { scene.visible = true; }
      scenes.push(scene);
    });
  }

  function bindParallax(root) {
    if (reduce) return;
    layers = layers.filter(function (x) { return x.el.isConnected; });
    (root || document).querySelectorAll('[data-ij-parallax] [data-ij-depth]:not([data-ij-bound])').forEach(function (el) {
      el.setAttribute('data-ij-bound', '');
      var depth = parseFloat(el.getAttribute('data-ij-depth')) || 0;
      if (depth > 0) layers.push({ el: el, depth: depth });
    });
  }

  function frame(t) {
    ticking = false;
    var y = window.pageYOffset, vh = window.innerHeight;
    var dt = lastT ? Math.max(t - lastT, 1) : 16;
    // px/ms をなめらかにした「いまのスクロールの速さ」
    speed += (Math.abs(y - lastY) / dt - speed) * 0.2;
    lastY = y; lastT = t;
    var settling = speed > 0.01;

    scenes.forEach(function (s) {
      if (!s.visible) return;
      var r = s.el.getBoundingClientRect();
      var run = s.el.offsetHeight - vh;
      var p = run > 0 ? clamp(-r.top / run, 0, 1) : 1;
      s.el.style.setProperty('--p', p.toFixed(4));

      if (s.lines.length) {
        var step = Math.min(s.lines.length - 1, Math.floor(p * s.lines.length * 0.999));
        if (p <= 0.02) step = s.lines.length > 1 ? 0 : step;
        if (step !== s.step) {
          s.lines.forEach(function (l, i) { l.classList.toggle('is-on', i === step); });
          s.step = step;
        }
      }

      var v = s.video;
      if (!v) return;
      if (s.mode === 'scrub') {
        if (v.duration && isFinite(v.duration)) {
          var target = p * (v.duration - 0.05);
          if (Math.abs(v.currentTime - target) > 0.033) { try { v.currentTime = target; } catch (e) {} }
        }
      } else if (s.mode === 'velocity') {
        // 止まっていれば等速、速く送るほど最大2.5倍まで速くなる
        var want = clamp(1 + speed * 1.6, 1, 2.5);
        s.rate += (want - s.rate) * 0.12;
        if (Math.abs(v.playbackRate - s.rate) > 0.02) { try { v.playbackRate = s.rate; } catch (e) {} }
        if (s.rate > 1.02) settling = true;
      }
    });

    layers.forEach(function (l) {
      var r = l.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      // 画面の中央を基準に、深さに比例して逆方向へずらす
      var off = (r.top + r.height / 2 - vh / 2) * -0.04 * l.depth;
      l.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });

    // 速度連動の動画が等速に戻りきるまでは、スクロールが止まってもフレームを回す
    if (settling) requestTick();
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  /* --- 9. ムードボードの動画：見えているときだけ再生する ----------- */
  function inviewVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-ij-inview-video]:not([data-ij-bound])');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.setAttribute('data-ij-bound', ''); v.preload = 'auto'; v.autoplay = true; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          if (!reduce) {
            // 省電力モードなどで自動再生を拒否された場合は、手動で再生できるよう操作ボタンを出す
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.controls = true; });
          }
        } else { v.pause(); }
      });
    }, { rootMargin: '15% 0px' });
    vids.forEach(function (v) {
      v.setAttribute('data-ij-bound', '');
      // 視差効果を減らす設定では自動再生しない代わりに、最初のコマを見せて手動で再生できるようにする
      if (reduce) { v.preload = 'metadata'; v.controls = true; v.removeAttribute('aria-hidden'); v.removeAttribute('tabindex'); }
      io.observe(v);
    });
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);

  function boot(root) {
    observeReveals(root);
    lightUpStatements(root);
    primeHeroVideo(root);
    buildMarquees(root);
    letters(root);
    smoothAnchors(root);
    bindImmersive(root);
    bindParallax(root);
    inviewVideos(root);
    requestTick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); stickyNav(); });
  } else {
    boot();
    stickyNav();
  }

  // テーマエディタでセクションを編集したときの再初期化
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
